// data was not requested at all
const BLANK = 'blank';
// data requesting in process
const PENDING = 'pending';
// data requesting finished
const IDLE = 'idle';

const LOADING_STATUSES = Object.freeze({
    BLANK,
    PENDING,
    IDLE,
});

function isBlank(data) {
    return data?.loading === BLANK;
}

function isPending(data) {
    return data?.loading === PENDING;
}

function isIdle(data) {
    return data?.loading === IDLE;
}

function isNotBlank(data) {
    return !isBlank(data);
}

function isNotPending(data) {
    return !isPending(data);
}

function isNotIdle(data) {
    return !isIdle(data);
}

module.exports = {
    LOADING_STATUSES,
    isBlank,
    isPending,
    isIdle,
    isNotBlank,
    isNotPending,
    isNotIdle,
};
